module.exports = __webpack_public_path__ + "media/images/transparent_spinner-a951cfd47acd55e5b45bdf6cbc42c3aa.gif";